import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { gEnums } from 'global/enums/globalEnums'
import { setStyleAndClass } from 'global/styles/formatting'
import React, { useContext, useMemo, useRef, useState } from 'react'
import { SwiperMenu } from './SwiperMenu'
import { Swiper } from 'swiper/react'

export const Swiper_Any = ({
  swKey,
  menuItems,
  extraButtons,
  groupDataProps,
  swipeContentType,
  swiperMenuType,
  isChild,
  applyFade = false,
  slides,
  showButtons,
}) => {

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {})

  const tabStyles = {
    tabsSnC: setStyleAndClass(aps_global, gEnums.projectStyles.tabs),
  }

  const swiperRef = useRef(null)

  const [activeIndex, setActiveIndex] = useState(0)

  // Swiper change → update activeIndex
  const handleSwiperChange = (swiper) => setActiveIndex(swiper.activeIndex)

  // Menu click → directly move swiper
  const handleMenuSelect = (index) => swiperRef.current?.slideTo(index)

  return (
    <div className="swiper-with-tabs tabz">
      {/* Menu */}
      {showButtons && <div className="swipe-menu-container tabs tabz" style={tabStyles.tabsSnC.style}      >
        <SwiperMenu
          swipeContentType={swipeContentType}
          menuItems={menuItems}
          extraButtons={extraButtons}
          groupDataProps={groupDataProps}
          swiperMenuType={swiperMenuType}
          activeIndex={activeIndex}
          handleIndexChange={handleMenuSelect}
        />
      </div>}
      {/* Swiper content */}

      {/* // modules={applyFade ? [EffectFade] : []}
          // effect={applyFade ? 'fade' : 'slide'}
          // fadeEffect={{ crossFade: true }} */}
      <div className="swiper-content-container tabz">
        <Swiper
          key={swKey}
          effect="slide"
          speed={100}
          slidesPerView={1}
          spaceBetween={20}
          threshold={10}
          resistance
          nested={isChild}
          touchMoveStopPropagation={isChild ? false : undefined}
          touchStartPreventDefault={isChild ? false : undefined}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          onSlideChange={handleSwiperChange}
        >
          {slides}
        </Swiper>
      </div>
    </div>
  )
}
